import { gql } from '@apollo/client';

export default gql`
  query placeLabel($id: ID!) {
    place(id: $id) {
      id
      name
    }
  }
`;
